import { createContext, useContext } from "react";
import { useFetch } from "../lib/useData";

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
  const { data } = useFetch("/public/settings");
  return <SettingsContext.Provider value={data || {}}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
